module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCIENT AND")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTIQUE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURCES")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1 Apoc. James")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(First) Revelation of James")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AESCHYLUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ag.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Agamemnon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cho.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Choephori")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eum.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eumenides")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prometheus vinctus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sept.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Septem contra Thebas")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Suppl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Supplices")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALCIDAMAS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Od.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Odysseus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALEXANDER OF APHRODISIAS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De fato")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Metaph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Aristotle’s Metaphysica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anth. gr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anthologie Graeca")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Ap. John")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Secret Book of John")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Apoc. Paul")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Revelation of Paul")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APOLLONIUS RHODIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Argon.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Argonautica")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARISTOCRITUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theo.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theosophia")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARISTOPHANES")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Av.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Aves")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ran.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ranae")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARISTOTLE")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cael.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De caelo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De an.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De anima")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. an.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia animalium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Metaph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Metaphysica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Poet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Poetica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rhet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Rhetorica")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AUGUSTINE")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Civ.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De civitate Dei")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conf.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Confessionum libri XIII")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Retract.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Retractationum libri II")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ver. rel.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De vera religione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("BG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Bhagavadgita")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("BP")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Bhagavata Purana")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("BU")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Brihadaranyaka Upanishad")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHALCIDIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Plat. Tim.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Plato’s Timaeus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CICERO")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Div.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De divinatione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fin.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De finibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De legibus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nat. d.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De natura deorum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tusc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tusculanae disputationes")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CLEMENT OF ALEXANDRA")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Protr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Protrepticus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Strom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stromateis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("CO")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Chaldean Oracles")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Corp. herm.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Corpus Hermeticum")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DAMASCIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De princ.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De principiis")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DEMETRIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eloc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De elocutione")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DIODORUS SICULUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib. hist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliotheca historica")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DIOGENES LAERTIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. phil.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vitae philosophorum")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DIONYSIUS THE AREOPAGITE")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Celestial Hierarchy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DM")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("On the Mysteries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DN")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Divine Names")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("EH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ecclesiastical Hierarchy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mystical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Disc. 8–9")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Discourse on the Eighth and Ninth")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EURIPIDES")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alcestis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bacch.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bacchae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heracl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heraclidae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hipp.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hippolytus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EUSEBIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dem. ev.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Demonstratio evangelica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. eccl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia ecclesiastica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Orat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oratio de Laudibus Constantini")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praep. ev.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praeparatio evangelica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Exeg. Soul")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Exegesis of the Soul")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GALEN")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("QAM")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Quod animi mores")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GELLIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Noct. att.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Noctes Atticae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gos. Judas")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gospel of Judas")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gos. Mary")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gospel of Mary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gos. Phil.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gospel of Philip")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gos. Truth")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Gospel of Truth")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERAKLEON")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Comm. John")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on the Gospel of John")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERMIAS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Plat. Phaedr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Plato’s Phaedrus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERODOTUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Historiae")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HESIOD")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Op.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Opera et dies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theog.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theogonia")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIPPOLYTUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Haer.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Refutatio omnium haeresium")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOMER")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Il.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Iliad")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Od.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Odyssey")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Hom. Hymn")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Homeric Hymns")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("(PSEUDO-)HYGINUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Astr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Astronomica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fab.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fabulae")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IAMBLICHUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De myst.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De mysteriis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theo. arith.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theologumena arithmeticae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. Pyth.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vita Pythagorae")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOHN OF SCYTHOPOLIS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SchEH")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Scholia: Ecclesiastical Hierarchy")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOHN SCOTTUS ERIUGENA")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Div. praed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De divina praedestinatione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Periph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Periphyseon")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JOSEPHUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("C. Ap.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Contra Apionem")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("J.W.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jewish War")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JULIAN")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Or.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Orationes")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LACTANTIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Inst.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Divine Institutes")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LUCIAN")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Musc. laud.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Muscae laudatio")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LYDUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De mens.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De mensibus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MACROBIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In somn. Scrip.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on the Dream of Scipio")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MARINUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. Proc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vita Proclii")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NONNUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dion.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dionysiaca")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("OF")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Orphic Fragments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("OH")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Orphic Hymns")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLYMPIODORUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Plat. Phaed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Plato’s Phaedo")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORIGEN")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cels.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Contra Celsum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Comm. Jo.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentarii in evangelium Joannis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Comm. Matt.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentarium in evangelium Matthaei")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Or.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De oratione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pasch.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De pascha")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Princ.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De principiis")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OVID")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Metam.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Metamorphoses")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PALAEPHATUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Incr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Incredibilia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Paraph. Shem")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Paraphrase of Shem")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PAUSANIAS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Descr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Description of Greece")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PHILO")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Abr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De Abrahamo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Contempl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De vita contemplativa")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fug.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De fuga et inventione")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Legum allegoriae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Migr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De migratione Abrahami")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Opif.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De opificio mundi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praem.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De praemiis et poenis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Somn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De somniis")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PHILOSTRATUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. Apoll.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vita Apollonii")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PHOTIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliotheca")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PINDAR")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Isthm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Isthmionikai")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Olympionikai")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pyth.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pythionikai")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PLATO")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alc. maj.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alcibiades major")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Apol.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Apologia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Charm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Charmides")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Crat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cratylus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Euthyd.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Euthydemus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gorg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Gorgias")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Leges")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Phaed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Phaedo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Phaedr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Phaedrus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Phileb.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Philebus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Resp.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Respublica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Soph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sophista")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Symp.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Symposium")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theaet.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theaetetus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tim.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Timaeus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PLETHON")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ad bess.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ad bessarionem")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De diff.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De differentiis")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PLOTINUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Enn.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Enneads")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PLUTARCH")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Adv. Colot.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Adversus Colotem")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alex.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alexander")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("An. Procr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De animae procreatione in Timaeo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Def. orac.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De defectu oraculorum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Is. Os.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De Iside et Osiride")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mor.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Moralia")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("(PSEUDO-)PLUTARCH")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Strom.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stromateis")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PORPHYRY")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Antr. nymph.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De antro nympharum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Christ.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Contra Christianos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Marc.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ad Marcellam")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. Plot.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vita Plotini")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. Pyth.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vita Pythagorae")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PROCLUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De aeter. mundi")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De aeternitate mundi")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De mal.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De malorum subsistentia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elem. theo.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elementatio theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Plat. Crat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Plato’s Cratylus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Plat. Parm.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Plato’s Parmenides")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Plat. Resp.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Plato’s Respublica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Plat. Tim.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Plato’s Timaeus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theo. Plat.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology of Plato")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Pr. Paul")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Prayer of the Apostle Paul")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PSEUDO-APOLLODORUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bib.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliotheca")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("RV")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Rigveda")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PSEUDO-DIONYSIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CD")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Corpus Dionysiacum")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SENECA")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ep.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistulae morales")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Herc. fur.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hercules furens")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oed.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oedipus")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SEXTUS EMPIRICUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Math.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Adversus mathematicos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pyrr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pyrrhoniae hypotyposes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("SU")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Shvetashvatara Upanishad")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SIMPLICIUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Arist. Cael.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Aristotle’s De Caelo")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Arist. De An.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Aristotle’s De Anima")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In Arist. Phys.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary on Aristotle’s Physica")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SOCRATES SCHOLASTICUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist. eccl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia ecclesiastica")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SOPHOCLES")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ant.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Antigone")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STOBAEUS")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ecl.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ecloge")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Flor.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Florilegium")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("STRABO")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Geogr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Geographica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Teach. Silv.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Teaching of Silvanus")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TERTULLIAN")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Praescr.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("De praescriptione haereticorum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Testim. Truth")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Testimony of Truth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Treat. Res.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Treatise on the Resurrection")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Tri. Trac.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Tripartate Tractate")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VERGIL")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Georg.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Georgica")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XENOPHON")])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mem.")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Memorabilia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Zost.")])]), _vm._v(" "), _c('td', {
    staticClass: "wid40"
  }, [_c('p', {
    staticClass: "t-leftt"
  }, [_vm._v("Zostrianos")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "abbr-h"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECONDARY")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURCES AND")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THER")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("BBREVIATIONS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AfO")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Archiv für Orientforschung")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AJP")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("American Journal of Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ANF")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Ante-Nicene Fathers")]), _vm._v(". Edited by Alexander Roberts and James Donaldson. 1885–1887. 10 vols. Repr., Peabody, MA: Hendrickson, 1994")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("AR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Archiv für Religionswissenschaft")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Berlin Gnostic")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Classical Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ClAnt")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Classical Antiquity")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ClQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Classical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CP")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Classical Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DK")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Fragmente der Vorsokratiker")]), _vm._v(". Edited by H. Diels and W. Kranz. 1903. 3 vols. Repr., Berlin: Weidmann, 1974")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("fr(r).")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("fragment(s)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("GOTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Greek Orthodox Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("GR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Greece and Rome")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("GRBS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Greek, Roman, and Byzantine Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Religions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HSCP")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Harvard Studies in Classical Philology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JAAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of the American Academy of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JECS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Early Christian Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Hellenistic Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JLARC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for Late Antique Religion and Culture")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JSSR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal for the Scientific Study of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("KAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Keilschrifttexte aus Assur religiösen Inhalts")]), _vm._v(". Edited by Erich Ebeling. Leipzig: Hinrichs, 1919–1923")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LCL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Loeb Classical Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LM")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Early Greek Philosophy")]), _vm._v(". Edited by A. Laks and G. Most. 9 vols. Cambridge, MA: Harvard University Press, 2016.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("LW")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Luther’s Works")]), _vm._v(". Edited by Jaroslav Pelikan and Helmut T. Lehman. 55 vols. Philadelphia: Fortress; St. Louis: Concordia, 1955–1986")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NAWG")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Nachrichten (von) der Akademie der Wissenschaften in Göttingen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NHC")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Nag Hammadi Corpus")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NovT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Novum Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NPNF")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nicene and Post-Nicene Fathers")]), _vm._v(", Series 1. Edited by Philip Schaff. 1886–1889. 14 vols. Repr., Peabody, MA: Hendrickson, 1994")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Graeca. Edited by J.-P. Migne. 162 vols. Paris, 1857–1886")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PGM")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Papyri Graecae Magicae: Die griechischen Zauberpapyri.")]), _vm._v(" Edited by Karl Preisendanz. 2nd ed. Stuttgart: Teubner, 1973–1974")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Phil")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Philologus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PL")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Latina. Edited by J.-P. Migne. 217 vols. Paris, 1844–1864")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ProEccl")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Pro Ecclesia")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SJT")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SPhilo")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Studia Philonica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SPhiloA")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia Philonica Annual")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("StPatr")])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia Patristica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SVTQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Vladimir’s Theological Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("TAPA")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Transactions of the American Philological Association")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("UF")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ugarit-Forschungen")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("VC")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vigiliae Christianae")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZNW")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "wid30"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZPE")])])]), _vm._v(" "), _c('td', {
    staticClass: "wid65"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Zeitschrift für Papyrologie und Epigraphik")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-714b58b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 75
// module chunks = 0